// extracted by css-extract-rspack-plugin
export default {"wrapper":"_85lh"};